import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "notes pointer-events-auto rounded border px-4 pb-6 mb-6" }
const _hoisted_2 = { class: "text-xs font-bold" }
const _hoisted_3 = {
  key: 1,
  class: "text-right"
}

import { computed, nextTick, ref } from 'vue'
import {
    IonItem,
    IonInput,
    IonButton
} from '@ionic/vue';

import { injectStrict } from '@/utils/injectTyped';
import { AxiosKey } from '@/symbols';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import serviceHelpers from '@/utils/serviceHelpers';
import getNotesQuery from '@/queries/getNotesQuery';


export default /*@__PURE__*/_defineComponent({
  __name: 'NotesBlock',
  setup(__props) {

const store = useStore();
const route = useRoute();

const authRole = computed(() => store.getters.authRole);
const service = computed(() => route.meta.service as string);
const matterType = computed(() => route.meta.type as string);
const reference = computed(() => route.params.reference as string);

const { getPermissionsFromService } = serviceHelpers();

const { data: notes, refetch } = getNotesQuery(service.value, matterType.value, reference.value);

const axios = injectStrict(AxiosKey);

const content = ref('');
const savingNote = ref(false);
const noteInputActive = ref(false);
const createNote = () => {
    savingNote.value = true;
    axios.post('/api/services/'+route.meta.service+'/notes/create/'+route.meta.type+'/'+route.params.reference, {
        content: content.value
    })
    .then(() => {
        refetch();
        savingNote.value = false;
        noteInputActive.value = false;
        content.value = '';
        scrollToElement();
    }).catch( () => {
        savingNote.value = false;
    });
}

const showNoteInputBox = () => {
    noteInputActive.value = true;
}

const noteBlock = ref(null) as any;
const scrollToElement = (): void => {
    nextTick(() => {
        if (noteBlock.value) {
            noteBlock.value.scrollTop = noteBlock.value.scrollHeight + 120;
        }
    });
    
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "border-b flex-grow w-full pb-3 relative" }, " Notes ", -1)),
    _createElementVNode("div", {
      class: "pointer-events-auto overflow-y-scroll max-h-60",
      ref_key: "noteBlock",
      ref: noteBlock
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notes), (note, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "rounded bg-gray-100 px-2 pt-1 pb-3 mb-2"
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(note.author) + " - " + _toDisplayString(note.created_at), 1),
          _createElementVNode("p", null, _toDisplayString(note.content), 1)
        ]))
      }), 128))
    ], 512),
    (noteInputActive.value)
      ? (_openBlock(), _createBlock(_unref(IonItem), {
          key: 0,
          lines: "none",
          class: "w-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonInput), {
              type: "text",
              modelValue: content.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((content).value = $event)),
              placeholder: "Note Content (min 10 characters)"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (authRole.value('edit-'+_unref(getPermissionsFromService)(service.value)))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (!noteInputActive.value)
            ? (_openBlock(), _createBlock(_unref(IonButton), {
                key: 0,
                onClick: _withModifiers(showNoteInputBox, ["prevent"])
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("New Note", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (noteInputActive.value)
            ? (_openBlock(), _createBlock(_unref(IonButton), {
                key: 1,
                disabled: content.value.length < 10 || savingNote.value,
                onClick: _withModifiers(createNote, ["prevent"])
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Add Note", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})